<template>
  <div class="wrapper">
    <div class="close-btn" @click="close">
      <Icon class="icon" :fill="'#719192'" :width="'20px'" :height="'20px'" :name="'close'"/>
    </div>
    <form>
      <p class="login-title">Login</p>
      <input type="text" placeholder="email address" v-model.trim="phone"/><br/>
      <input type="password" placeholder="password" v-model.trim="password"/><br/>
      <a @click="forgot" class="forgotpwd">forgot password?</a>
      <a @click="register" class="register">no account? Sign Up</a>
      <div class="footer">
        <p class="button" @click.prevent="login">Login</p>
        <label class="savepwd"><input type="checkbox" :checked="savePwd" @change="toggleSave"><span>&nbsp;remember me</span></label>
      </div>
    </form>
  </div>
</template>
<script>
import Icon from '@/components/Reusables/Icon'
import {Login} from '@/api/index.js'
import Cookies from 'js-cookie'
import {mapState, mapMutations} from 'vuex'

  export default {
    name: 'LoginPage',
    components:{
      Icon,
    },
    data() {
      return {
        phone:null,
        password:null,
        savePwd:false,
      };
    },
    computed:{
      ...mapState({
        stateSavePwd: state => state.user.savePwd
      }),
    },
    mounted(){
      //biar pas refresh atau balik ke login status savePwdnya masih sama kyk sebelumnya,
      //jadi savePwdnya harus ikutin status yang di cookie, true or falsenya
      this.savePwd = this.stateSavePwd;
      if(this.stateSavePwd){
        let loginData = Cookies.get('loginData');
        if(JSON.parse(loginData)){
          let data = JSON.parse(loginData);
          this.phone = data.phone;
          this.password = data.password;
        }
      }

    },
    methods:{
      login(){
        if(!this.phone||!this.password){
          window.alert('username/password wrong');
          return;
        }

        let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!reg.test(this.phone)){
          window.alert('email address not valid!');
          return;
        }

        Login({'email':this.phone,'password':this.password}).then(res=>{
        // Login({'mobile':this.phone,'password':this.password}).then(res=>{
          this.$store.commit('user/MU_SaveUserInfo',res.data);
          // Cookies.set('userData',{'userdata':res.data});
          if(this.savePwd){
            Cookies.set('loginData',{
              'phone':this.phone,
              'password':this.password
            });
          }
          window.alert('welcome :)');
          window.setTimeout(function(){
            window.location.href="/network";
          },2000);
        })
      },
      toggleSave(){
        this.savePwd = !this.savePwd;
        this.$store.commit('user/MU_SavePwd',this.savePwd);
      },
      closelogin(){
        this.$emit('closelogin');
      },
      showRegister(){
        this.$emit('showRegister');
      },
      showForgot(){
        this.$emit('showForgot');
      },
      register(){
        this.$store.commit('setCred', 'register')
      },
      forgot(){
        this.$store.commit('setCred', 'forgot')
      },
      close(){
        this.$store.commit('setCred', null)
      }
    },
  };
</script>
<style lang="" scoped>
@import './Reusables/cred.css';
  .wrapper{
    width: calc(480px - 60px);
    height: calc(580px - 60px);
    padding: 30px;
  }
  input[type="text"],input[type="password"]{
    border: 0;
    background: transparent;
    border-bottom: 4px solid #719192;
    width: 100%;
    font-size: 22px;
    padding-bottom: 10px;
    margin-bottom: 40px;
    color: #719192;
  }
  input[type="password"]{
    margin-bottom: 50px
  }

  input:focus{
    outline: none;
    /* border-color: red; */
  }
  .login-title{
    font-size: 30px;
    font-weight: bold;
    text-align: right;
    margin-bottom: 50px;
    color: #719192;
  }
  .forgotpwd, .register, .savepwd{
    font-size: 15px;
    color:#719192;
    text-decoration: none;
    display: block;
  }

  .forgotpwd, .register{
    margin-bottom: 5px;
  }
  a:hover, .savepwd:hover{
    text-decoration: underline;
    cursor: pointer;
  }
  .savepwd{
    /* margin-bottom: 0; */
    text-align: center;
  }
  .button{
    background: #719192;
    width: 100%;
    text-align: center;
    font-size: 32px;
    padding: 13px 0;
    color: #fff;
    border-radius: 10px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .button:hover{
    cursor: pointer;
  }

  @media screen and (max-width: 900px){
    .login-page{
      width: 70%;
      max-width: 450px;
      min-width: 220px;
      padding:30px;
      margin-top: 120px;
    }
    input[type="text"],input[type="password"]{
      width: 90%;
      border-radius: 0;
      border-bottom: 3px solid #859D9F;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue